import React from "react";

const Footer = () => (
  <footer className="border-t border-line">
    <div className="mx-auto flex max-w-content flex-wrap items-center justify-between gap-4 px-6 py-8">
      <p className="font-mono text-xs text-faint">
        © {new Date().getFullYear()} Madhu Varsha
      </p>
      {/* <button
        type="button"
        onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
        className="py-2 font-mono text-xs text-muted underline-offset-4 transition-colors duration-100 hover:text-fg hover:underline"
      >
        Back to top ↑
      </button> */}
    </div>
  </footer>
);

export default Footer;
